import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { IAppConfig } from '../Config/app-config.model';
import { UserModel } from '../user/UserModel';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationService {

  constructor(private httpClient: HttpClient, @Inject('appconfig') private configParam: IAppConfig) { }

  GetRedirectionUrl(user: UserModel): Observable<any> {
    const reqModel = {
      authToken: user.ApiToken,
      user: user.UserName,
      role: user.Role
    };

    return this.httpClient.post<any>(`${this.configParam.CoreConfig.USERROLE_API_ENDPOINT}/user/validate-token`, reqModel);
  }

  GetUserRole(token: string): Observable<any> {
    return this.httpClient.get<any>(`${this.configParam.CoreConfig.USERROLE_API_ENDPOINT}/user?token=${token}`);
  }
}
